export default "assets/images/icons/google-plus-5e1d494f.svg";